/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import { default as JSG, TextFormatAttributes, Rectangle } from '@cedalo/jsg-core';
import NodeView from './NodeView';

/**
 * This view is for a {{#crossLink "SplitterNode"}}{{/crossLink}} model. Although it
 * can be instantiated directly the recommended way to create this view is by calling
 * {{#crossLink "NodeController/createView:method"}}{{/crossLink}} method.
 *
 * @class CaptionView
 * @extends NodeView
 * @param {SplitterNode} item The corresponding SplitterNode model.
 * @constructor
 */
export default class CaptionView extends NodeView {
	drawFill(graphics, format, rect) {
		super.drawFill(graphics, format, rect);
		const item = this.getItem();
		const textFormat = item.getTextFormat();

		const color = format.getFillColor().getValue();
		//
		// graphics.setFillColor(color);
		// graphics.fillRect(rect);

		textFormat.applyToGraphics(graphics);
		graphics.setFontSize(9);
		graphics.setFont();
		graphics.setTextAlignment(TextFormatAttributes.TextAlignment.LEFT);
		graphics.setTextBaseline('middle');
		textFormat.removeFromGraphics(graphics);

		let title;
		let icon = false;
		switch (item.getType().getValue()) {
		case 'inboxcaption':
			if (item.properties) {
				title = `${JSG.getLocalizedString('Inbox')}`;
				if (item.connections && item.connections.length) {
					title += ` - ${item.connections.length}`;
					icon = true;
				}
			}
			break;
		case 'sheetcaption':
			if (item.properties) {
				title = `${item.properties.name} - ${JSG.getLocalizedString('Step')} ${item.properties.stats.steps}`
			}
			break;
		default:
			title = JSG.getLocalizedString(item.getName().getValue());
			break;
		}

		graphics.setFillColor(JSG.theme.captiontext);
		graphics.fillText(title, rect.x + 200, rect.y + rect.height / 2 + 20);
		const width = graphics.getCoordinateSystem().deviceToLogX(graphics.measureText(title).width, true);
		if (width > rect.width - 1025) {
			const rectEl = rect.copy();
			rectEl.x = rect.width - 1200;
			rectEl.width = 1200;
			graphics.setFillColor(color);
			graphics.fillRect(rectEl);
			graphics.setFillColor(JSG.theme.captiontext);
			graphics.fillText('...', rectEl.x, rect.y + rect.height / 2 + 20);
		}
		if (icon) {
			graphics.drawImage(
				JSG.imagePool.get('connections'),
				width + 300,
				50,
				400,
				400
			);
		}
	}
}
